import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { toSHA256 } from '../utils/hash';
import init from 'jest-fail-on-console';


export interface AccessIdState {
  accessId: string | undefined;
  initialized: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class AccessIdService {
  public accessIdState$ = new BehaviorSubject<AccessIdState>({
    accessId: undefined,
    initialized: false,
  });

  constructor() {
    this.accessIdState$.subscribe((state) => {
      console.log('accessIdState Changed', state)
    })

  }

  public currentAccessId() {
    return this.accessIdState$.getValue().accessId
  }

  public setAccessId(accessId?: string) {
    console.log('setAccessId', accessId)
    this.accessIdState$.next({
      initialized: true,
      accessId: accessId,
    })
  }

  public clearAccessId() {
    this.accessIdState$.next({
      initialized: true,
      accessId: undefined,
    })
  }


}
